import { AbstractControl, ValidatorFn } from '@angular/forms'

import { FileInput } from '../file-input.model'

export class FileValidator {
  /**
   * Function to control content of files
   *
   * @param bytes max number of bytes allowed
   *
   * @returns
   */
  static maxContentSize(bytes: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const size = control && control.value ? (control.value as FileInput).files.map(f => f.size).reduce((acc, i) => acc + i, 0) : 0
      const condition = bytes >= size

      return condition
        ? null
        : {
          maxContentSize: {
            actualSize: size,
            maxSize: bytes,
          },
        }
    }
  }

  /**
   * Function to control extension and mime type of files
   *
   * @param allowedFileTypes list of mimes or extensions
   *
   * @returns
   */
  static extensions(allowedFileTypes: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fileTypes = control && control.value ? (control.value as FileInput).files.map(f => ({
        extension: f.name.split('.').pop(),
        mime: f.type,
      })) : null
      const forbiddenExtensions = []

      fileTypes?.forEach((fileType) => {
        if (!allowedFileTypes.find((allowedType) => {
          if (allowedType.includes('/')) {
            const mimeArr = fileType.mime.split('/')
            const allowedMimeArr = allowedType.split('/')

            return ((mimeArr[0] === allowedMimeArr[0] || allowedMimeArr[0] === '*') &&
            (mimeArr[1] === allowedMimeArr[1] || allowedMimeArr[1] === '*'))
          } else {
            return fileType.extension === allowedType.replace('.', '')
          }
        })) {
          forbiddenExtensions.push(fileType.extension)
        }
      })

      return forbiddenExtensions.length
        ? {
          extensions: {
            forbiddenExtensions: forbiddenExtensions,
          },
        } : null
    }
  }
}
